"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerWallet = void 0;
const _1 = require(".");
const provider_1 = require("./provider");
/**
 * Wallet based on a Signer.
 */
class SignerWallet {
    constructor(signer) {
        this.signer = signer;
    }
    get publicKey() {
        return this.signer.publicKey;
    }
    signAllTransactions(transactions) {
        return Promise.resolve(transactions.map((tx) => {
            tx.partialSign(this.signer);
            return tx;
        }));
    }
    signTransaction(transaction) {
        transaction.partialSign(this.signer);
        return Promise.resolve(transaction);
    }
    /**
     * Creates a Provider from this Wallet by adding a Connection.
     * @param connection
     * @returns
     */
    createProvider(connection, sendConnection) {
        return new provider_1.SolanaProvider(connection, new _1.SingleConnectionBroadcaster(sendConnection !== null && sendConnection !== void 0 ? sendConnection : connection), this);
    }
}
exports.SignerWallet = SignerWallet;
//# sourceMappingURL=wallet.js.map